import { createFileRoute, Outlet } from '@tanstack/react-router'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import { contentWrapper } from '~/pages/styles/Dashboard.css'

const SettingsLayout = (): ReactElement => {
  return (
    <div className={clsx(contentWrapper)}>
      <Outlet />
    </div>
  )
}

export const Route = createFileRoute('/_dashboard/settings')({
  component: SettingsLayout
})
